export function getScenarioImportPayloadErrorMessages(data) {
	if (data && typeof data === "object") {
		if (Array.isArray(data.baseline_configs) || Array.isArray(data.baseline_items)) {
			return [
				"Invalid Scenario import file.",
				" ",
				"Baseline export data cannot be imported through the Scenario import flow.",
			];
		}
	}

	if (!data || typeof data !== "object" || !data.baseline || typeof data.baseline !== "object") {
		return ["Invalid import payload.", " ", "Please verify the JSON file format."];
	}

	return null;
}
